module.exports = __webpack_public_path__ + "static/5-724ec37976353e5df6c83ebf2e9a6383.jpg";